import MoreHorizIcon from "@mui/icons-material/MoreHoriz"

const WaitingChanges = () => <MoreHorizIcon />

export { WaitingChanges }
